import React from 'react';

const MentionsLegalesPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-900 to-gray-800">
      <div className="max-w-4xl mx-auto px-4 py-16">
        <h1 className="text-5xl font-black mb-8 text-[#e2b13c] text-center">
          Mentions Légales
        </h1>

        <div className="bg-[#0f172a] border-2 border-[#e2b13c] rounded-lg p-8 text-gray-200 space-y-6">
          <section>
            <h2 className="text-2xl font-bold text-[#e2b13c] mb-4">Éditeur du Site</h2>
            <div className="space-y-2">
              <p><strong>Raison sociale :</strong> SAS VTC DES WEPPES</p>
              <p><strong>Adresse :</strong> 15 rue de Ligny, 59134 Beaucamps-Ligny</p>
              <p><strong>Capital social :</strong> 1 500 €</p>
              <p><strong>SIRET :</strong> 918 489 659 00014</p>
              <p><strong>RCS :</strong> Lille Métropole 918 489 659</p>
              <p><strong>TVA intracommunautaire :</strong> FR 77 918 489 659</p>
            </div>
          </section>

          <div className="h-px bg-[#e2b13c]"></div>

          <section>
            <h2 className="text-2xl font-bold text-[#e2b13c] mb-4">Contacts</h2>
            <div className="space-y-2">
              <p><strong>Téléphone urgence (Patrick) :</strong> 06 95 73 13 20</p>
              <p><strong>Téléphone bureau (Catherine) :</strong> 09 67 56 26 73</p>
              <p><strong>Email :</strong> contact@vtcdesweppeslille.fr</p>
            </div>
          </section>

          <div className="h-px bg-[#e2b13c]"></div>

          <section>
            <h2 className="text-2xl font-bold text-[#e2b13c] mb-4">Hébergement</h2>
            <p><strong>Hébergeur :</strong> HOSTINGER</p>
            <p className="text-sm text-gray-400 mt-2">
              Sites web hébergés : vtcdesweppeslille.fr et vtcdesweppeslille.com
            </p>
          </section>

          <div className="h-px bg-[#e2b13c]"></div>

          <section>
            <h2 className="text-2xl font-bold text-[#e2b13c] mb-4">Assurance</h2>
            <div className="space-y-2">
              <p><strong>Assureur :</strong> Thélem Assurance</p>
              <p><strong>Contrat Responsabilité Civile Professionnelle :</strong> TMRP13225089</p>
            </div>
          </section>

          <div className="h-px bg-[#e2b13c]"></div>

          <section>
            <h2 className="text-2xl font-bold text-[#e2b13c] mb-4">Directeur de publication</h2>
            <p>Patrick Blondel, Fondateur</p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default MentionsLegalesPage;